/*global webkit*/
/*global Android*/
import Actions from 'flow/actions';
import { getSignalIosMenuFinishedLoading } from 'flow/utils/browser-utils';

/**
 * Set the application into embedded state.
 */
export const setAppEmbedded = (type) => ({
    type: Actions.APP_EMBEDDED,
    data: type,
});

/**
 * Post a message to iOS.
 */
const postMessage = (msg) => {
    if (typeof webkit !== 'undefined') {
        if (webkit.messageHandlers) {
            webkit.messageHandlers.webappHandler.postMessage(
                JSON.stringify(msg),
            );
        } else {
            console.warn('No WebKit message handlers', msg);
        }
    } else {
        console.warn('WebKit is not defined', msg);
    }
};

/**
 * Signals to Android that the web app should exit.
 */
export const androidExitApp = () => () => {
    if (typeof Android !== 'undefined') {
        Android.exit();
    }
};

/**
 * Signal to Android that authentication is required.
 */
export const androidNeedAuth = () => () => {
    if (typeof Android !== 'undefined') {
        Android.needAuth();
    }
};

/**
 * Signal to Android that we have finished loading.
 */
export const androidFinishedLoading = () => () => {
    if (typeof Android !== 'undefined') {
        Android.finishedLoading();
    }
};

/**
 * Signal to Android that we have menu finished loading.
 */
export const androidMenuFinishedLoading = () => () => {
    if (typeof Android !== 'undefined') {
        Android.menuFinishedLoading();
    }
};

/**
 * Signal to iOS that the web app should exit.
 */
export const iosExitApp = () => () => {
    postMessage({
        action: 'EXIT_APP',
    });
};

/**
 * Signal to iOS that the web app needs auth.
 */
export const iosNeedAuth = () => () => {
    postMessage({
        action: 'NEED_AUTH',
    });
};

/**
 * Signal to iOS that the web app finished loading.
 */
export const iosFinishedLoading = () => () => {
    postMessage({
        action: 'FINISHED_LOADING',
    });
};

/**
 * Signal to iOS that the web app menu finished loading.
 */
export const iosMenuFinishedLoading = () => () => {
    if (getSignalIosMenuFinishedLoading()) {
        postMessage({
            action: 'MENU_FINISHED_LOADING',
        });
    }
};
